import type { ReactNode } from 'react';

export const symbol_work_update: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-180v-21.75V-180v-480 480Zm0 60q-24 0-42-18t-18-42v-480q0-24 18-42t42-18h180v-100q0-23 18-41.5t42-18.5h200q24 0 42 18.5t18 41.5v100h180q24 0 42 18t18 42v177q0 12.64-8.68 20.82-8.67 8.18-21.5 8.18-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-176H140v480h304q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H140Zm240-600h200v-100H380v100Zm204 616q-57-57-57-136t57-136q57-57 136-57t136 57q57 57 57 136t-57 136q-57 57-136 57t-136-57Zm121-79-67-67q-5-5-10-5t-10 5q-5 5-5 10.5t5 10.5l81 82q9 9 21 9t21-9l82-82q5-5 5-10.5t-5-10.5q-5-5-10.5-5t-10.5 5l-67 67v-156q0-6-4.5-10.5T720-354q-6 0-10.5 4.5T705-339v156Z"
		/>
	</svg>
);
